(function () {
  var controllerId = "supportMenuController";
  angular
    .module("app")
    .controller(controllerId, ["$rootScope", "$scope", "$location","routeService","mapService","eventTracker",
      function menuController($rootScope, $scope, $location,routeService,mapService,eventTracker) {
        $scope.currentPath = $location.path();
        $scope.home = function () {
          $location.url("/app");
        };
        $scope.onLogOut = function () {
          var checkRoutes = routeService.checkUnsavedRoutes();
          if (checkRoutes) {
            mapService.clearSavedCenterZoom();
            routeService.deleteAllRoutes();
            eventTracker.track(eventTracker.EVENTS.LOGOUT);
           
          }
          return checkRoutes;
        };
        $scope.goToAccount = function () {
          eventTracker.track("Clicks My Account");
          $location.url("/account");
        };
      }
    ]);
})();


// WEBPACK FOOTER //
// ./app/layout/supportMenu.controller.js